import axios from 'axios';

const apiInfo = axios.create({
  baseURL:
    'https://dadosgeociencias.ibge.gov.br/server/rest/services/Hosted/IBGE/FeatureServer',
});

export interface GetDataHeaderPropsLike {
  camada_busca: string;
  cod_ligacao_busca: string;
}

export interface GetDataPropsLike {
  camada: string;
  categoria?: string;
  order_by?: string;
  cod_ligacao: string;
  value: any;
}

export const AgolService = {
  async getParamHeader() {
    const response = await apiInfo.get(
      '/1/query?where=1%3D1&outFields=*&f=json'
    );
    return response;
  },
  async getDataHeader(props: GetDataHeaderPropsLike, codMun: string) {
    const apiData = axios.create({
      baseURL: props.camada_busca,
    });

    const response = await apiData.get(
      `/query?where=${props.cod_ligacao_busca}='${codMun}'&outFields=*&f=json`
    );
    return response;
  },
  async getParamIndicators(category) {
    const response = await apiInfo.get(
      `/0/query?where=UPPER(categoria)='${category.toUpperCase()}'&outFields=*&f=json`
    );
    return response;
  },
  async getData(props: GetDataPropsLike) {
    const apiData = axios.create({
      baseURL: props.camada,
    });

    let categoryWhere = '';
    if (props.categoria) {
      categoryWhere = ` and (UPPER(categoria)='${props.categoria.toUpperCase()}')`;
    }
    const orderByFields = `orderByFields=${props.order_by || ''}`;

    const value =
      typeof props.value === 'string' ? `'${props.value}'` : props.value;
    const response = await apiData.get(
      `/query?where=${props.cod_ligacao}=${value}${categoryWhere}&outFields=*&${orderByFields}&returnGeometry=false&f=json`
    );
    return response;
  },
  async getParamTable(category) {
    const response = await apiInfo.get(
      `/2/query?where=UPPER(categoria)='${category.toUpperCase()}'&outFields=*&returnGeometry=false&f=json`
    );
    return response;
  },
  async getParamIndicatorChart(category) {
    const response = await apiInfo.get(
      `/3/query?where=UPPER(categoria)='${category.toUpperCase()}'&outFields=*&returnGeometry=false&f=json`
    );
    return response;
  },
  async getCovidInfoChart(category) {
    const apiData = axios.create({
      baseURL:
        'https://dadosgeociencias.ibge.gov.br/server/rest/services/Hosted/GRAFICOS_CASOS_OBITOS/FeatureServer/0',
    });

    const response = await apiData.get(
      `/query?where=UPPER(categoria)='${category.toUpperCase()}'&outFields=*&returnGeometry=false&f=json`
    );
    return response;
  },
  async getFeatureByPoint(layerUrl, mapPoint, outFields = '*') {
    const apiData = axios.create({
      baseURL: layerUrl,
    });

    const spatialReference = mapPoint?.spatialReference?.wkid ?? 102100;
    const queryData = {
      returnGeometry: 'false',
      geometry: JSON.stringify(mapPoint),
      geometryType: 'esriGeometryPoint',
      inSR: spatialReference,
      outSR: spatialReference,
      spatialRel: 'esriSpatialRelIntersects',
      maxAllowableOffset: '1',
      resultRecordCount: '1',
      outFields,
      where: '1=1',
      f: 'json',
    };

    const query = Object.keys(queryData)
      .map((key) => {
        return key + '=' + queryData[key];
      })
      .join('&');
    const response = await apiData.get(`/query?${query}`);
    return response;
  },
};
